export enum UserAvatarColor {
	GRAY = 'gray',
	BLUE = 'blue',
	GREEN = 'green',
	PINK = 'pink'
}
